import image1 from '../Images/Hungry.png';
import image2 from '../Images/Askservice.png';
import image3 from '../Images/circle2.png';
import image4 from '../Images/portfolio.png';

export default function Projects() {
    return (
        <div className="projects" id="projects">
            <h2 className="color project_tag">Projects</h2>
            <div className="project_items">
                <div className="project_item">
                    <a href="#home">
                        <img src={image1} alt="HungryClub" />
                        <div className="project_info">
                            <h2>A Perfect Food Ordering Website</h2>
                            <h3>Built with React</h3>
                        </div>
                    </a>
                </div>
                <div className="project_item">
                    <a href="https://github.com/Prerna092002/AskService" target='blank'>
                        <img src={image2} alt="AskService" />
                        <div className="project_info">
                            <h2> Find Employment Or Hire Workers</h2>
                            <h3>Built with Exp, Ejs, MongoDb</h3>
                        </div>
                    </a>
                </div>
                <div className="project_item">
                    <a href="https://kashishgoyal905.github.io/Circle2/" target='blank'>
                        <img src={image3} alt="Circle2" />
                        <div className="project_info">
                            <h2>Resturant</h2>
                            <h3>Built with Html, Css, Js</h3>
                        </div>
                    </a>
                </div>
                <div className="project_item">
                    <a href="https://portfolioo-07.web.app" target='blank'>
                        <img src={image4} alt="Portfolio" />
                        <div className="project_info">
                            <h2>My Personal Portfolio</h2>
                            <h3>Built with React</h3>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
}